import { UploadSimple, Sparkle } from "@phosphor-icons/react";
import {
  AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function CopyNeedsImageDialog({ open, onOpenChange, onUpload, onGenerate, generating }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="copy-needs-image-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Add your own image to go public</AlertDialogTitle>
          <AlertDialogDescription>
            This recipe started as a copy of another cook&apos;s recipe. To share your version in the public Directory it needs its own image — the original cook&apos;s photos will be removed from your public version. Upload a fresh photo or generate an AI image, then tap Save again.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex flex-col sm:flex-row gap-3">
          <button type="button" data-testid="copy-needs-image-upload" onClick={onUpload} className="btn-amber flex-1 justify-center">
            <UploadSimple size={16} /> Upload a photo
          </button>
          <button type="button" data-testid="copy-needs-image-ai" onClick={onGenerate} disabled={generating} className="btn-outline-ink flex-1 justify-center">
            <Sparkle size={16} /> {generating ? "Generating…" : "Generate AI image"}
          </button>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="copy-needs-image-cancel">Not now</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
